import React from 'react'

/**
 * MImage Props - Standard HTML img element
 */
export interface IMImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
	src: string
	alt: string
}

/**
 * MImage - Standard Image Component
 *
 * Simple wrapper around standard HTML img element
 *
 * @example
 * ```tsx
 * <MImage src="/image.jpg" alt="Description" width={500} height={300} />
 * ```
 */
export const MImage: React.FC<IMImageProps> = (props) => {
	return <img {...props} />
}

MImage.displayName = 'MImage'
